// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCCshX9ikaWKfpM36T-YaXiekJlpQzJOI0",
  authDomain: "pgs-web-f3949.firebaseapp.com",
  projectId: "pgs-web-f3949",
  storageBucket: "pgs-web-f3949.firebasestorage.app",
  messagingSenderId: "715816445482",
  appId: "1:715816445482:web:6ad4e555d54c369cb8c553",
  measurementId: "G-9L7KTQQZNS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);


